export default "__VITE_ASSET__pXLATOCt__"